import { gql } from 'types/__generated__/gql';
import gqlTag from 'graphql-tag';

// TODO: Including both variants here until we have time to consolidate.
export const KEYBOARDING_CLASSROOM_EXPORT_FRAGMENT_LEGACY = gqlTag`
  fragment BaseKeyboardingClassroomExportLegacy on KeyOrganizationClassroomEngagementReportResult {
    classroom {
      id
      name
      sisId
      organizationId
      organization {
        id
        name
      }
      licenseUsage(where: { productFamily: { code: "KEY" } }) {
        assignedCount
      }
    }
    activeStudentCount
    totalStudentCount
    totalActivitiesCompletedCount
    averageWeeklyMinutesSpent
    curriculumProgressPercentage
  }
`;

const KEYBOARDING_CLASSROOM_EXPORT_FRAGMENT = gql(/* GraphQL */ `
  fragment BaseKeyboardingClassroomExport on KeyOrganizationClassroomEngagementReportResult {
    classroom {
      id
      name
      sisId
      organizationId
      organization {
        id
        name
      }
      licenseUsage(where: { productFamily: { code: "KEY" } }) {
        assignedCount
      }
    }
    activeStudentCount
    totalStudentCount
    totalActivitiesCompletedCount
    averageWeeklyMinutesSpent
    curriculumProgressPercentage
  }
`);

export default KEYBOARDING_CLASSROOM_EXPORT_FRAGMENT;
